import { createStyles, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PERMISSIONS } from '../../const/permissions.const';
import { createTradingTimesFormRows } from '../../formSchemas/tradingTimes.form';
import useCheckPermissions from '../../hooks/useCheckPermissions';
import { ITradingTime } from '../../interfaces/ITradingTimes';
import DynamicForm from '../../yoello-lib/modules/dynamicForms/DynamicForms';
import EColourPanel from '../../yoello-lib/modules/dynamicForms/interfaces/EColourPanel';

interface ITradingTimesFormProps {
    onSubmit: (data: ITradingTime) => Promise<void>;
    formData: ITradingTime | Record<string, string>;
    newTradingTime: any;
}

const useStyles = makeStyles(() => createStyles({
    root: {
        "& form": {
            "& >div>div:last-child": {
                display: "flex",
                justifyContent: "flex-end",
            },
        },
    },
    submitButton: {
        marginLeft: "auto",
        marginTop: "20px",
        float: "right",
    },
    leftButton: {
        display: "none",
    },
    active: {
        display: "flex !important",
        "&>*>div": {
            float: "right"
        }
    }
}))

export function TradingTimesForm({
    onSubmit,
    formData,
    newTradingTime
}: ITradingTimesFormProps) {
    const { root, submitButton, active, leftButton } = useStyles();
    const { t } = useTranslation();

    const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.VENUE_MANAGEMENT);

    async function handleSubmit(data: unknown) {
        const tData = data as ITradingTime;
        onSubmit({ ...tData, id: formData?.id })
    }

    return (
        <Grid
            key={formData?.id ?? "NewTradingTime"}
            container
            className={
                `${root} tradingTime`
            }
            data-component-name="TRADING_TIME_ITEM"
            id={formData?.id ?? "NewTradingTime"}
            ref={newTradingTime}
        >
            <DynamicForm
                onHandleSubmit={handleSubmit}
                formData={formData}
                formRows={createTradingTimesFormRows(t, active)}
                formKeyName="TradingTimes"
                disableAll={!hasPermission}
                disableAllInteraction={onFailedInteraction}
                formButtons={{
                    rightButton: {
                        type: "submit",
                        label: t("forms.tradingTimes.save"),
                        color: EColourPanel.PRIMARY,
                        fullWidth: false,
                        className: submitButton,
                        disabled: !hasPermission
                    },
                    leftButtonCustomClassName: leftButton,
                    rightCols: 4,
                }}
            />
        </Grid>
    )
}